import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const DocumentWithCutIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 23 27",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 15),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: /*#__PURE__*/jsx("path", {
      d: "M21.4 23.7a1.9 1.9 0 0 1-1.8 1.8H2.9A1.9 1.9 0 0 1 1 23.7V3.2a1.9 1.9 0 0 1 1.9-1.8H12l9.3 9.3v13ZM6.6 8.8h3.7M6.6 14.4h9.3M6.6 20h9.3"
    })
  });
};

export { DocumentWithCutIcon };
//# sourceMappingURL=document.cut.js.map
